
$.extend tower,
  initReportEvents: ->
    renderDate $('.events-day:first')
    scrollLoad()


renderDate = ($event) ->
  today = moment().startOf('day')
  date = moment $event.data('date')

  if date.isSame(today, 'day')
    $event.find('.events-day-title').text '今'
  else if date.isSame(today.clone().subtract(1, 'd'), 'day')
    $event.find('.events-day-title').text '昨'

scrollLoad = ->
  tower.scrollLoad $('.page-inner'), ($btn) ->
    date = $('.events-day:last').data('previous-date')
    unless date
      $btn.removeClass('loading').addClass('over').text('没有更多内容了')
      return
    $.ajax
      url: location.href
      type: 'get'
      dataType: 'html'
      data:
        date: date
      success: (result) ->
        return unless result
        $result = $(result)
        renderDate $result
        tower.adjustReadableTime $result
        tower.initPermission $result
        $('.reports-evnets').append $result
